import { CompanyListWidgetRenderer} from "../renderer/CompanyListWidgetRenderer";
import { CompanyListWidgetRequestDto } from "../dtos/CompanyListRequestDto";
import { InfiniteScrollHelper , ResponseCallback} from "../libs/infinite-scroll-helper";
import { IResponse, IResponseWithData, RequestType } from "../libs/request-helper";
import { CompanyEntryDto } from "../dtos/CompanyEntryDto";

declare var BASE_URL: any;
declare var API_VERSION: any;
export class CompanyListWidget implements ResponseCallback {
    protected static ERROR_MSG = "Es konnten leider keine Unternehmen gefunden werden!";
    protected static REQUEST_URL = "api/" + API_VERSION + "/PublicData/PublicCompanyInfosBySearchQuery";
    protected companiesContainer: HTMLElement;
    protected mainContainer: HTMLElement;
    protected requestDto: CompanyListWidgetRequestDto;
    protected companyListWidgetRenderer: CompanyListWidgetRenderer;
    protected static firstInit = true;
    protected scrollHelper : InfiniteScrollHelper;
    protected listItemCount = 0;

    protected static async init(): Promise<void> {
        if(CompanyListWidget.firstInit){
            CompanyListWidget.firstInit = false;
            document.addEventListener('DOMContentLoaded', CompanyListWidget.onDocumentLoaded, false);
        }
    }

    constructor(private target: HTMLElement, private id: String) {
        const attr = JSON.parse(this.target.getAttribute("data-companylist-attr"));
        const scrollable = this.target.getAttribute("data-container-scrollable");
        if(attr == null) {
			return;
        }
        this.requestDto = attr;
        this.requestDto.pageNumber = 0;
        this.companiesContainer = <HTMLElement> this.target.getElementsByClassName("companiesContainer")[0];
        if(attr.radius) {
            this.requestDto.radius = Number(attr.radius);
        }
        if(attr.maxItems) {
            this.requestDto.maxItems = Number(attr.maxItems);
        } else {
            this.requestDto.maxItems = Infinity;
        }
        this.companyListWidgetRenderer = new CompanyListWidgetRenderer(this.companiesContainer, CompanyListWidget.ERROR_MSG);
        let scroll: any = window;
        if(scrollable) {
            scroll = this.companiesContainer
        }

        this.scrollHelper = new InfiniteScrollHelper(
            this.companiesContainer,
            this,
            this.requestDto,
            BASE_URL + CompanyListWidget.REQUEST_URL,
            RequestType.LIST_WIDGET,
            scroll
        );
    }


    protected static onDocumentLoaded() {
        const companyLists = document.getElementsByClassName("companyList");

        for(let i = 0; i < companyLists.length; ++i) {
			const companyList = companyLists[i];
			const instance = new CompanyListWidget(companyList as HTMLElement, i.toString());
        }
    }

    public responseCallback(res: IResponse): boolean {
        if (res.requestError) {
            this.companyListWidgetRenderer.renderError()
            return false
        }

        var response = <IResponseWithData<Array<CompanyEntryDto>>>res;
        var responseDto = response.data as Array<CompanyEntryDto>;
        //check if new data was available
        if (responseDto.length == 0) {
            return false;
        }
        this.requestDto.pageNumber = this.requestDto.pageNumber + 1;
        //Render JobOffers Items
        this.scrollHelper.setRequestDto(this.requestDto);
        for (var i = 0; i < responseDto.length; i++) {
            this.companyListWidgetRenderer.renderJobGiverItem(responseDto[i]);
            if ((this.listItemCount + i + 1) >= this.requestDto.maxItems) {
                //do not display remaining items if total count would be larger than max item count
                return false;
            }
        }
        this.listItemCount = this.listItemCount + responseDto.length;
        return true;
    }
}